<template>
  <div class="close">
     <mt-header title="关闭项目">
      <mt-button icon="back" slot="left" @click.native="$router.go(-1)">取消</mt-button>
    </mt-header>
    <div class="content">
      <h1>是什么原因让你决定关闭项目 </h1>
      <input type="radio" checked name="select1" @click="hidden(1)"><label for="select1">通过其他方式找到了合作者</label>
      <br/>
      <input type="radio" name="select1" @click="hidden(2)"><label for="select1">通过自己公司内部来做</label>
      <br/>
      <input type="radio" name="select1" @click="hidden(3)"><label for="select1">项目不做了</label>
      <br/>
      <input type="radio" name="select1" @click="showInputOnes(4)"><label for="select1">不想在云智图做了</label>
      <br/>
      <input type="text" v-model="inputText" v-if="showInputOne">
      <input type="radio" name="select1" @click="showInputTwos(5)"><label for="select1">其他原因</label>
      <br/>
      <input type="text" v-model="inputText" v-if="showInputTwo">
    </div>
    <div class="btns">
      <button type="button" @click="cancel">取消</button>
      <button type="button" @click="confirm">确认</button>
    </div>
  </div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
export default {
  name: 'close',
  data () {
    return {
      showInputOne: false,
      showInputTwo: false,
      inputText: '',
      num: 0,
      projectId: '',
      projectStatus: ''
    }
  },
  mounted () {
    this.STATE.state.myProjectDetailId = this.$route.query.projectId
    this.projectId = this.$route.query.projectId
    this.projectStatus = this.$route.query.projectStatus
    console.log(this.$route.query.projectStatus)
    console.log(this.projectStatus)
  },
  methods: {
    showInputOnes: function (num) {
      this.num = num
      this.showInputTwo = false
      this.showInputOne = true
    },
    showInputTwos: function (num) {
      this.num = num
      this.showInputOne = false
      this.showInputTwo = true
    },
    hidden: function (num) {
      this.num = num
      this.showInputOne = false
      this.showInputTwo = false
    },
    cancel: function () {
      this.$router.go(-1)
    },
    confirm: function () {
      Indicator.open({
        text: '关闭中...',
        spinnerType: 'fading-circle'
      })
      let _this = this
      this.axios({
        method: 'post',
        url: '/url/work/project/updatestatus',
        params: {
          closedFlag: this.num,
          closedReason: this.inputText,
          projectId: this.projectId,
          status: this.projectStatus
        }
      }).then(function (response) {
        Indicator.close()
        let msg = ''
        if (response.data.success) {
          msg = '关闭成功'
        } else {
          msg = response.data.msg
        }
        Toast({
          message: msg,
          position: 'middle',
          duration: 1000
        })
        _this.$router.go(-1)
      }).catch(function (response) {
        Indicator.close()
        Toast({
          message: '关闭失败',
          position: 'middle',
          duration: 1000
        })
      })
    }
  }
}
</script>

<style scoped>
.content{
  padding:20px 15px;
}
.content h1{
  margin-bottom: 15px;
  font-weight: bold;
}
.content input{
  font-size: 12px;
  display: inline-block;
  vertical-align: middle;
}
.content label{
  font-size: 12px;
  display: inline-block;
  vertical-align: middle;
}
.content input[type=text]{
  font-size: 14px;
  width: 100%;
  border: none;
  border-bottom: 1px solid #ccc;
  margin: 5px 0;
  outline: none;
}
.btns{
    text-align: center;
    margin-top:40%;
  }
  .btns button{
    width: 40%;
    height: 30px;
    border: none;
    outline: none;
    border-radius:5px;
    -webkit-border-radius:5px;
    -moz-border-radius:5px;
    margin: 0 5px;
    color: #fff;
  }
  .btns button:nth-child(1){
    background-color: #808080;
  }
  .btns button:nth-child(2){
    background-color: #108ee9;
  }
</style>


// WEBPACK FOOTER //
// closePjt.vue?77c9a8f2